export {default} from './Button'



// WEBPACK FOOTER //
// ./src/UI/Button/index.js